var _this = this,
    _jsxFileName = "/builds/zillow/adtech-product/constellation/zrs-cms-messaging/src/img/AppHome.jsx";

import React from 'react';
import PropTypes from 'prop-types';

var AppHome = function AppHome(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/React.createElement("svg", {
    width: "44",
    height: "44",
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: className,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.6 20.85C29.6 21.55 29.3 22.25 28.8 22.85L23.7 27.95L18.6 22.85C18.1 22.35 17.8 21.65 17.8 20.85C17.8 20.05 18.1 19.35 18.6 18.85C19.1 18.35 19.9 18.05 20.6 18.05C21.3 18.05 22 18.35 22.6 18.85L23.8 20.05L25 18.85C26.1 17.75 27.9 17.75 29 18.85C29.4 19.45 29.6 20.15 29.6 20.85Z",
    fill: "#F2A619",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 13,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1 13.75L25.1 2.45C24.2 1.85 23.1 1.85 22.2 2.45L10.2 13.75C9.70001 14.25 9.39999 14.85 9.39999 15.55V33.55C9.39999 34.85 10.5 35.95 11.8 35.95H35.7C37 35.95 38.1 34.85 38.1 33.55V15.55C38 14.85 37.7 14.25 37.1 13.75ZM28.8 22.85L23.7 27.95L18.6 22.85C18.1 22.35 17.8 21.65 17.8 20.85C17.8 20.05 18.1 19.35 18.6 18.85C19.1 18.35 19.9 18.05 20.6 18.05C21.3 18.05 22 18.35 22.6 18.85L23.8 20.05L25 18.85C26.1 17.75 27.9 17.75 29 18.85C29.5 19.35 29.8 20.05 29.8 20.85C29.6 21.55 29.4 22.25 28.8 22.85Z",
    fill: "#A6E5FF",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 17,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2 5.94995H8.39999C7.09999 5.94995 6 7.04995 6 8.34995V39.5499C6 40.8499 7.09999 41.95 8.39999 41.95H25.2C26.5 41.95 27.6 40.8499 27.6 39.5499V8.34995C27.6 7.04995 26.5 5.94995 25.2 5.94995ZM25.2 39.5499H8.39999V34.75H25.2V39.5499ZM25.2 32.35H8.39999V15.55H25.2V32.35ZM25.2 13.15H8.39999V8.34995H25.2V13.15Z",
    fill: "#0D4599",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 21,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8 38.35C17.4627 38.35 18 37.8127 18 37.15C18 36.4872 17.4627 35.95 16.8 35.95C16.1372 35.95 15.6 36.4872 15.6 37.15C15.6 37.8127 16.1372 38.35 16.8 38.35Z",
    fill: "#0D4599",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 25,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6 11.9499H18C18.7 11.9499 19.2 11.4499 19.2 10.7499C19.2 10.0499 18.7 9.54993 18 9.54993H15.6C14.9 9.54993 14.4 10.0499 14.4 10.7499C14.4 11.4499 14.9 11.9499 15.6 11.9499Z",
    fill: "#0D4599",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 29,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 11.9499C12.6627 11.9499 13.2 11.4127 13.2 10.7499C13.2 10.0872 12.6627 9.54993 12 9.54993C11.3373 9.54993 10.8 10.0872 10.8 10.7499C10.8 11.4127 11.3373 11.9499 12 11.9499Z",
    fill: "#0D4599",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 33,
      columnNumber: 9
    }
  }));
};

AppHome.propTypes = process.env.NODE_ENV !== "production" ? {
  className: PropTypes.string
} : {};
AppHome.defaultProps = {
  className: null
};
export default AppHome;